import * as Yup from 'yup';

export const validationSchema = Yup.object({
  password: Yup.string()
    .min(4, 'Minimum length is 4 symbols')
    .required('Password is required'),
});